export function recordToQueryParams(
  record?: Record<string, string | boolean | number | undefined>
): string {
  if (!record) return '';

  const strings = Object.entries(record)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value], index) => {
      if (index === 0) {
        return `?${key}=${value}`;
      }
      return `&${key}=${value}`;
    });

  return strings.join('');
}
